export const normalizeList = (value) => {
  if (Array.isArray(value)) {
    return value.map(item => String(item).trim()).filter(Boolean);
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map(item => item.trim())
      .filter(Boolean);
  }

  if (value === null || value === undefined || value === '') {
    return [];
  }

  return [String(value).trim()].filter(Boolean);
};

export const normalizeMarketIntelligenceItem = (item) => {
  const publishedAt = item?.published_at || item?.created_at || new Date().toISOString();
  const topics = normalizeList(item?.topics);
  const sector = normalizeList(item?.sector);
  const region = normalizeList(item?.region);
  const audience = normalizeList(item?.audience);
  const tags = normalizeList(item?.tags);
  const contentBlocks = Array.isArray(item?.content_blocks) ? item.content_blocks : [];
  const assetRefs = Array.isArray(item?.asset_refs) ? item.asset_refs : [];

  return {
    id: item?.id,
    slug: item?.slug || item?.id,
    title: item?.title || 'Untitled insight',
    subtitle: item?.subtitle || item?.excerpt || '',
    excerpt: item?.excerpt || item?.subtitle || '',
    content: item?.content || '',
    content_type: item?.content_type || 'insight',
    template_key: item?.template_key || 'editorial_article',
    visibility: item?.visibility || 'public',
    category: item?.category || 'General',
    author_name: item?.author_name || 'ALICE Research Team',
    author_role: item?.author_role || '',
    published_at: publishedAt,
    created_at: item?.created_at || publishedAt,
    read_time_minutes: item?.read_time_minutes || 5,
    is_featured: Boolean(item?.is_featured),
    featured_rank: Number(item?.featured_rank || 0),
    featured_image: item?.featured_image || '',
    featured_image_alt: item?.featured_image_alt || item?.title || '',
    media_type: item?.media_type || '',
    media_url: item?.media_url || '',
    video_url: item?.video_url || '',
    video_duration_seconds: item?.video_duration_seconds || null,
    video_caption: item?.video_caption || '',
    external_url: item?.external_url || '',
    hero_headline: item?.hero_headline || '',
    hero_supporting_line: item?.hero_supporting_line || '',
    primary_cta_label: item?.primary_cta_label || '',
    primary_cta_url: item?.primary_cta_url || '',
    secondary_cta_label: item?.secondary_cta_label || '',
    secondary_cta_url: item?.secondary_cta_url || '',
    topics,
    sector,
    region,
    audience,
    tags,
    content_blocks: contentBlocks,
    asset_refs: assetRefs,
    raw: item || {}
  };
};

export const formatMarketDate = (dateValue) => {
  if (!dateValue) return '';
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const getPrimaryVideoDurationLabel = (seconds) => {
  if (!seconds && seconds !== 0) return '';
  return `${seconds}s`;
};

export const clampText = (text, maxLength = 150) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trim()}...`;
};

export const MARKET_INTELLIGENCE_FALLBACK_IMAGE = '/business-impact-image.png';

export const handleMarketImageError = (event) => {
  const element = event?.currentTarget;
  if (!element) return;
  if (element.dataset.fallbackApplied === 'true') return;
  element.dataset.fallbackApplied = 'true';
  element.src = MARKET_INTELLIGENCE_FALLBACK_IMAGE;
};
